import { Injectable } from '@angular/core';
import {MediaConnection} from "peerjs";
import {error, log} from "../functions";
import {UserCall} from "../types/video.calls.type";

@Injectable({
  providedIn: 'root'
})
export class WebrtcService {
  usersVideoList: any[] = [];
  roomId: string | number;
  localStream: MediaStream;
  isErrorDisplayMedia = false;
  private displayMediaOptions: DisplayMediaStreamConstraints = {};
  private mediaOptions: MediaStreamConstraints = {
    video: {
      width: {
        max: 500,
      },
      height: {
        max: 500
      },
      // facingMode: 'user',
    },
    audio: true
  };
  isSupportShareScreen = !!navigator.mediaDevices?.getDisplayMedia;
  constructor() {}
  getUserStream(type: 'audio' | 'video' | 'share') {
    return ((type === 'audio' || type === 'video') ? this.getUserFullMedia(type) : this.shareScreenStream())
  }
  getUserFullMedia(type: 'audio' | 'video' = 'video') {
    if ( this.userMediaAvailable() ) {
      return navigator.mediaDevices.getUserMedia( {
        video: type === 'video',
        audio: {
          echoCancellation: true,
          // noiseSuppression: true
        }
      } );
    }

    else {
      throw new Error( 'User media not available' );
    }
  }
  shareScreenStream() {
    if ( this.userMediaAvailable() ) {
      return navigator.mediaDevices.getDisplayMedia( {
        video: {
          // cursor: "always"
        },
        audio: {
          echoCancellation: true,
          // noiseSuppression: true,
          sampleRate: 44100
        }
      } );
    }

    else {
      throw new Error( 'User media not available' );
    }
  }
  userMediaAvailable() {
    return !!( (navigator as any).getUserMedia || (navigator as any).webkitGetUserMedia || (navigator as any).mozGetUserMedia || (navigator as any).msGetUserMedia );
  }
  replaceStream(peerConnections: RTCPeerConnection[], stream: MediaStream) {
    const videoTrack = stream.getVideoTracks()[0];
    log('replaceStream', peerConnections);
    peerConnections.forEach((pc) => {
      const sender: RTCRtpSender = pc.getSenders().find((s) => {
        return s.track.kind === videoTrack.kind;
      });
      if(sender) {
        console.log('found sender:', sender);
        sender.replaceTrack(videoTrack);
      }else{
        pc.addTrack(videoTrack, stream);
        // TODO
        error('!sender');
      }
    });
  }

  // stop only mic
  setAudioEnabled(stream: MediaStream, enable = true): void {
    stream.getTracks().forEach((track) => {
      if (track.readyState === 'live' && track.kind === 'audio') {
        track.enabled = enable;
      }
    });
  }
  isMuteStream(stream: MediaStream) {
    if (!stream) { return; }
    let mutedCount = 0;
    stream.getAudioTracks().forEach((track) => {
      log(track);
      if (track.muted) {
        mutedCount += 1;
        log(mutedCount);
      }
    });
    return mutedCount === 0;
  }


  // stop both mic and camera
  stopBothVideoAndAudio(stream: MediaStream): void {
    try {
      stream.getTracks().forEach((track) => {
        if (track.readyState === 'live') {
          track.stop();
        }
      });
    }catch ($e) {

    }

    // this.cd.detectChanges();
  }

  // stop only camera
  stopVideoOnly(stream: MediaStream): void {
    stream.getTracks().forEach((track) => {
      if (track.readyState === 'live' && track.kind === 'video') {
        track.stop();
      }
    });
    // this.cd.detectChanges();
  }
  videoStreamInit(video: HTMLVideoElement, user) {
    // this.zone.runOutsideAngular(() => {
    user.video = video;
    if (user.stream) {
      video.playsInline = true;
      this.videoStreamReplace(user.userId, user.stream);
    } else {
      console.error('!user.stream');
    }
    // })
  }
  videoStreamReplace(userId: string, stream: MediaStream) {
    const user = this.getUserCallBuId(userId);
    user.stream = stream;
    if (!user.video) {
      throw new Error('!user.video');
    }
    this.setVideoStream(user.video, user.stream);
  }
  setVideoStream(video: HTMLVideoElement, stream: MediaStream) {
    if ('srcObject' in video) {
      try {
        video.srcObject = stream;
        video.addEventListener('loadedmetadata', () => {
          video.play();
          // this.cd.detectChanges();
        });
        log('stream', stream, video);
      } catch (err) {
        if (err.name !== "TypeError") {
          throw err;
        }
        video.src = URL.createObjectURL(stream as any);
      }
    } else {
      video.src = URL.createObjectURL(stream as any);
    }
  }
  getUserCallBuId(id = 'self', revert = false): UserCall {
    return this.usersVideoList.find((v) => revert ? (v?.userId !== id) : (v?.userId === id))
  }
}
